import { WEB_API_ROUTES } from 'api/api-routes';
import { createThunk } from '../../utils/storeUtils';
import { apiWrapper } from '../../api/apiWrapper';

const thunks = {
  getList: createThunk('classes/getList', () =>
    apiWrapper.get(WEB_API_ROUTES.classes.list)
  ),
};

export { thunks };
